import { SingleDatePicker } from 'react-dates'
import 'react-dates/initialize'
import React from 'react'
import useTranslation from 'hooks/UseTranslation'
import { Button } from 'reactstrap'
import moment from 'moment'

const DateQuickAccess = ({ date, setDate, noneDate, isOutsideRange = (d => d.isSameOrBefore(moment().subtract(1, 'day'))) }) => {
  const { t } = useTranslation()
  const [isCalendarFocused, setIsCalendarFocused] = React.useState(false)

  return <div className='d-flex flex-column'>
    <div className='d-flex justify-content-start'>
      <Button onClick={() => setDate(date.clone().subtract(1, 'week').startOf('day'))} color='link'>
        <i className='fa fa-angle-left' />
        <i className='fa fa-angle-left' />
      </Button>
      <Button onClick={() => setDate(date.clone().subtract(1, 'day').startOf('day'))} color='link'>
        <i className='fa fa-angle-left' />
      </Button>
      <SingleDatePicker
        readOnly
        id='date'
        numberOfMonths={1}
        date={date}
        block
        small
        isOutsideRange={isOutsideRange}
        onDateChange={d => setDate((d || (noneDate || moment)()).startOf('day'))}
        focused={isCalendarFocused}
        onFocusChange={({ focused }) =>
          setIsCalendarFocused(focused)
        }
        showClearDate
        orientation='horizontal'
      />
      <Button onClick={() => setDate(date.clone().add(1, 'day').startOf('day'))} color='link'>
        <i className='fa fa-angle-right' />
      </Button>
      <Button onClick={() => setDate(date.clone().add(1, 'week').startOf('day'))} color='link'>
        <i className='fa fa-angle-right' />
        <i className='fa fa-angle-right' />
      </Button>
    </div>
  </div>

}

export default DateQuickAccess